import React, { useState, useContext, createContext, useEffect } from "react";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Button from '@mui/material/Button';
import { Typography } from "@mui/material";
import AdminEventCard from "./AdminEventCard";
import Grid from '@mui/material/Grid';
import { BrowserRouter, BrowserRouter as Router, Route, Switch } from "react-router-dom"
import { Link } from "react-router-dom";
import AdminCreateNewEvent from "./AdminCreateNewEvent";
import AdminSingleEvent from "./AdminSingleEvent";
import { AppContext } from "../../App";

export const EventContext = createContext()

export default function AdminEvents(){

  const { activeUser, setChangesMade } = useContext(AppContext)

  const [overviewMode, setOverviewMode] = useState(true)
  const [singleViewMode, setSingleViewMode] = useState(false)
  const [selectedEvent, setSelectedEvent] = useState("")
  const [events, setEvents] = useState([])

  useEffect(()=> {
      async function getEvents(){
        const user = activeUser.username
        const response = await fetch(`https://the-paper-pusher.herokuapp.com/getAllEvents/${user}`)
          if (!response.ok) {
            const message = `An error occurred: ${response.statusText}`;
            window.alert(message);
            return;
          }
          const events = await response.json();
          setEvents(events)
      }
      getEvents()
      setChangesMade(prev => prev+1)
  },[])

  return (
    <div className="admin-events-main">
      <EventContext.Provider value ={{ setOverviewMode, setSingleViewMode, selectedEvent, setSelectedEvent, events }}>
      {singleViewMode ? 
      <AdminSingleEvent /> :

      (overviewMode ?  
      <div>
        <h3>Events</h3>
        <Button variant="outlined" startIcon={<AddCircleOutlineIcon />} onClick={()=>setOverviewMode(false)}>
          Create New Event
        </Button>
        <Typography sx={{marginBottom: '3em', marginTop: '3em'}}>
          Upcoming Events
        </Typography>
        <Grid container spacing={2}>
          {events.map((event) => {
            return (
              <Grid sx={{padding: '0.5em'}} item xs={6}>
                <AdminEventCard id={1} name={event.eventDetails.eventName} date="22 August 2022"/>
              </Grid>
            )
          })}
        </ Grid>
 
      
      </div> : 
      <AdminCreateNewEvent />)
        }
        </EventContext.Provider>
    </div>
  )
}